export default "__VITE_PUBLIC_ASSET__60db4443__"